const path = require('path');
const ctx = require.context("./attr",false,/\.vue$/);
const modules = {};
ctx.keys().forEach(key=>{
   const name = path.basename(key, '.vue')
   modules[name] = ctx(key).default || ctx(key)
})

export default {
    ...modules
}



// WEBPACK FOOTER //
// ./src/pages/cashier/components/cashierdiaryTable/components.js